import React from "react";
import { Route } from "react-router-dom";
import Academic from "./Academic";
import Individuals from "./Individuals";
import Organizations from "./Organizations";
import Translation from "./Translation";

const Service = () => {
  return (
    <>
      <Route path="/services/translation" component={Translation} />
      <Route path="/services/academic" component={Academic} />
      <Route path="/services/organizations" component={Organizations} />
      <Route path="/services/individuals" component={Individuals} />
    </>
  );
};

export default Service;
